var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.dialogTitle,
      confirmText: _vm.$gettext("Auswählen"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Abbrechen"),
      closeClass: "cancel",
      confirmDisabled: !_vm.hasSelection,
      height: _vm.height,
      width: _vm.width,
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.selectId,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                staticClass: "file-chooser-content",
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "file-chooser-folder-selector",
                  },
                  [
                    _vm.courseId && _vm.allowCourseFolders
                      ? _c(
                          "li",
                          {
                            staticClass: "file-chooser-tree-item",
                          },
                          [
                            _c(
                              "a",
                              {
                                class: {
                                  selected: _vm.coursesRootFolderSelected,
                                },
                                attrs: {
                                  href: "#",
                                },
                                on: {
                                  click: function click($event) {
                                    $event.preventDefault()
                                    return _vm.setFolder("courses")
                                  },
                                },
                              },
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "seminar",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$gettext("Diese Veranstaltung"))
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "file-chooser-tree file-chooser-tree-first-level",
                              },
                              _vm._l(
                                _vm.coursesTree.children,
                                function (child) {
                                  return _c("file-chooser-tree", {
                                    key: child.id,
                                    attrs: {
                                      folder: child,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userId && _vm.allowUserFolders
                      ? _c(
                          "li",
                          {
                            staticClass: "file-chooser-tree-item",
                          },
                          [
                            _c(
                              "a",
                              {
                                class: {
                                  selected: _vm.usersRootFolderSelected,
                                },
                                attrs: {
                                  href: "#",
                                },
                                on: {
                                  click: function click($event) {
                                    $event.preventDefault()
                                    return _vm.setFolder("users")
                                  },
                                },
                              },
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "content",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$gettext("Arbeitsplatz"))),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "file-chooser-tree file-chooser-tree-first-level",
                              },
                              _vm._l(_vm.usersTree.children, function (child) {
                                return _c("file-chooser-tree", {
                                  key: child.id,
                                  attrs: {
                                    folder: child,
                                  },
                                })
                              }),
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("file-chooser-box", {
                  attrs: {
                    excludedFolderTypes: [].concat(
                      _vm.excludedCourseFolderTypes,
                      _vm.excludedUserFolderTypes
                    ),
                  },
                  on: {
                    selectId: _vm.selectId,
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }